<template>
  <div class="content-image-select">
    <div class="content-block">
      <label class="input-title">{{ component.label }}</label>

      <div class="action-buttons">
        <div class="image-and-camera-buttons">
          <v-tooltip left>
            <template v-slot:activator="{}">
              <v-btn icon color="#0eca27">
                <v-icon>mdi-image-plus</v-icon>
              </v-btn>
            </template>
            <span>Adicionar Imagem</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{}">
              <v-btn icon color="#0eca27">
                <v-icon>mdi-camera-plus</v-icon>
              </v-btn>
            </template>
            <span>Adicionar Câmera</span>
          </v-tooltip>
        </div>

        <div
          class="chevron-and-counter"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <v-tooltip left>
            <template v-slot:activator="{}">
              <v-btn icon color="#0eca27" @click="toggleIcon">
                <v-icon>{{
                  isDown ? 'mdi-chevron-down' : 'mdi-chevron-up'
                }}</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
          <span>0/4</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MultipleImageSelect',

  props: {
    component: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isDown: true,
    }
  },
  methods: {
    toggleIcon() {
      this.isDown = !this.isDown
    },
  },
}
</script>
<style scoped>
.content-image-select {
  display: flex;
  flex-direction: column;
  padding: 10px;
  max-width: 100%;
}
.content-block {
  /* Mantém display: flex e align-items: center */
  background-color: #eeeeee;
  border: 1px solid #dddddd;
  border-radius: 8px;
  color: #69739e;
  padding: 5px;
  display: flex;
  /* Removendo justify-content: space-between; pois o flex-grow fará o trabalho */
  align-items: center;
}

.input-title {
  font-family: 'Rajdhani', sans-serif;
  color: #69739e;
  padding-left: 5px;
  /* CHAVE: Faz o label crescer e empurrar o grupo de botões para a direita */
  flex-grow: 1;
}

.action-buttons {
  /* CHAVE: Alinha os dois subgrupos (Imagem/Câmera E Chevron/Contador) LADO A LADO */
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px; /* Espaço entre o grupo de botões de Imagem/Câmera e o botão Chevron */
}

.image-and-camera-buttons {
  /* Garante que os botões de Imagem e Câmera fiquem lado a lado */
  display: flex;
  flex-direction: row;
  align-items: center;
}

/* O estilo abaixo já existia e garante que o contador fique abaixo do ícone */
.chevron-and-counter {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
